import React from "react";
import { useParams } from "react-router-dom";
import { KnownAllergiesCard } from "./medicines/KnownAllergiesCard";
import { PatientMedicationsCard } from "./medicines/PatientMedicationsCard";
import { PastPrescriptionsCard } from "./medicines/PastPrescriptionsCard";

interface MedicinesHomeProps {
  isCompleted?: boolean;
}

export const MedicinesHome = ({ isCompleted = false }: MedicinesHomeProps) => {
  const params = useParams<{ appointmentId: string }>();
  const appointmentId = params.appointmentId || "";

  return (
    <div className="h-full overflow-hidden flex flex-col gap-3 p-4">
      {/* Top Row: Past Prescriptions */}
      <div className="min-h-0 flex-1">
        <PastPrescriptionsCard appointmentId={appointmentId} />
      </div>

      {/* Bottom Row: Patient Shared + Known Allergies */}
      <div className="grid grid-cols-1 md:grid-cols-[1fr_2fr] gap-3 min-h-0 flex-1">
        <PatientMedicationsCard appointmentId={appointmentId} />
        <KnownAllergiesCard
          appointmentId={appointmentId}
          isCompleted={isCompleted}
        />
      </div>
    </div>
  );
};
